// Generated by CoffeeScript 2.7.0
var EditTagGroupModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

export default EditTagGroupModal = Vue.extend({
  components: {
    'modal': Modal
  },
  props: {
    title: {
      type: String
    },
    initialTagName: {
      type: String,
      default: ''
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      tagName: this.initialTagName,
      valid: true
    };
  },
  template: `<modal :title="title"
       extendClass="tag-group-modal"
       @ensureClicked="ensureClicked"
       size='small'
       ref="tagModalRef">
  <template>
    <div class="modal-body mt-5">
      <div class="form-field required" :class="{ 'has-error': !valid }">
        <div class="form-field-head">
          <div class="form-field-title">标签名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="form-field-value" placeholder="请输入标签名称" type="text" v-model.trim="tagName">
          </div>
          <div class="message">请输入标签名称</div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  methods: {
    ensureClicked: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.tagModalRef.open();
        return;
      }
      return this.callback(this.tagName);
    },
    _validate: function() {
      return this.valid = Boolean(this.tagName);
    }
  }
});
